import React from "react";
import AuthenticationPageComponent from "../../common/AuthenticationPageComponent";
import AuthenticationButtonSubmit from "../../common/AuthenticationButtonSubmit";

export default ({onClick}) => (
    <AuthenticationPageComponent icon="abs_refresh_mail"
                                 subtitle="fw.authentication.resetPassword.success.formSubtitle"
                                 className="authentication-success-page"
    >
        <form id="resetPasswordSuccessForm"
              className="authentication-form"
        >

            <AuthenticationButtonSubmit labelKey="fw.authentication.redirectToLoginPage"
                                        onClick={onClick}/>

            <div className="clearfix"/>
        </form>
    </AuthenticationPageComponent>
);
